(function() {
  function walkShadow(root, cb) {
    cb(root);
    var all = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      cb(el);
      if (el.shadowRoot) walkShadow(el.shadowRoot, cb);
    }
  }

  function applyWishlistHeartFix() {
    walkShadow(document, function(el) {
      if (!el.classList) return;
      if (el.classList.contains('Vtl-WishlistButton__IconWrapper') || el.classList.contains('Vtl-WishlistHeader__IconWrapper')) {
        el.style.setProperty('color', '#E4002B', 'important');
      }
      if (el.classList.contains('Vtl-WishlistIcon__Wrapper')) {
        el.style.setProperty('top', 'auto', 'important');
        el.style.setProperty('left', 'auto', 'important');
        el.style.setProperty('right', '10px', 'important');
        el.style.setProperty('bottom', '10px', 'important');
      }
    });
  }

  applyWishlistHeartFix();

  var scheduled = false;
  var observer = new MutationObserver(function() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function() {
      applyWishlistHeartFix();
      scheduled = false;
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  setInterval(applyWishlistHeartFix, 1500);
})();
